<template>
  <div>
    <main>
      <Banner />
      <PdkHeader />

      <div>
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </main>
    <PdkFooter />
  </div>
</template>

<script>
import Banner from "@/components/tour/TourBanner";
import PdkHeader from "../../components/PdkHeader";
import PdkFooter from "@/components/PdkFooter";

export default {
name:"Tourism",
  components: { Banner, PdkFooter, PdkHeader },

}
</script>